//@ts-ignore
import AdminIcon from "../../../ui/img/navigate/shield-keyhole.svg"
import { adminRoleList, allRoleList, regularRoleList, USER_PERMISSION, USER_ROLE } from "../../../../constants"
import { lang } from "../../../../constants/languages"

const navElements = [
  {
    name: lang.navigation.overview,
    iconPath: "/navigation_icons/overview.svg",
    href: "/overview",
    bgColor: "#ffffff",
    permittedRoles: allRoleList,
    bRadius: 2,
    type: "link"
  },
  {
    name: lang.navigation.releases,
    iconPath: "/navigation_icons/music.svg",
    href: "/catalog",
    bgColor: "#ffffff",
    permittedRoles: regularRoleList,
    bRadius: 2,
    type: "link"
  },
  {
    name: lang.navigation.reports,
    iconPath: "/navigation_icons/presentation-chart.svg",
    href: "/reports",
    bgColor: "#ffffff",
    permittedRoles: regularRoleList,
    bRadius: 10,
    type: "link"
  },
  {
    name: lang.navigation.analytics,
    iconPath: "/navigation_icons/analytics.svg",
    href: "/analytics",
    bgColor: "#ffffff",
    permittedRoles: allRoleList,
    bRadius: 2,
    type: "link"
  },
  {
    name: lang.navigation.trends,
    iconPath: "/navigation_icons/trends.svg",
    href: "/daily-trends",
    bgColor: "#ffffff",
    permittedRoles: regularRoleList,
    bRadius: 2,
    type: "link"
  },
  {
    name: lang.navigation.artist_space,
    iconPath: "/navigation_icons/earth.svg",
    href: "/artist-space",
    bgColor: "#ffffff",
    permittedRoles: regularRoleList,
    bRadius: 10,
    type: "link"
  },
  {
    name: lang.navigation.affiliate,
    iconPath: "/navigation_icons/affiliate.svg",
    href: "/affiliate",
    bgColor: "#ffffff",
    attributeToCheck: "affiliateCount",
    permittedRoles: allRoleList,
    bRadius: 10,
    type: "link"
  },
  {
    name: lang.navigation.playlists,
    iconPath: "/navigation_icons/playlists.svg",
    href: "/playlists",
    bgColor: "#ffffff",
    permittedRoles: regularRoleList,
    bRadius: 10,
    type: "link"
  },
  {
    name: lang.navigation.marketing,
    iconPath: "/navigation_icons/soundwave.svg",
    href: "/marketing",
    bgColor: "#ffffff",
    permittedRoles: allRoleList,
    permissionToCheck: USER_PERMISSION.UPLOAD_MARKETING,
    bRadius: 10,
    type: "link"
  },
  {
    name: "Admin",
    iconPath: AdminIcon,
    bgColor: "#ffffff",
    href: "/admin/user-asset",
    permittedRoles: adminRoleList,
    bRadius: 10,
    type: "link"
    // sublinks are deprecated now
    /*sublinks: [
      {
        name: "User Asset",
        href: "/user-asset",
        iconPath: TeamLineIcon,
        permittedRoles: [USER_ROLE.SuperAdmin, USER_ROLE.DistroAdmin]
      },
      {
        name: "Asset Registry (Releases)",
        href: "/catalog",
        iconPath: "/navigation_icons/music.svg",
        permittedRoles: adminRoleList
      },
      {
        name: "Royalty Reports",
        href: "/royalty-reports",
        iconPath: "/navigation_icons/chart.svg",
        permittedRoles: [USER_ROLE.SuperAdmin]
      },
      {
        name: "Reports Approval",
        href: "/reports-approval",
        iconPath: FileChartLineIcon,
        permittedRoles: [USER_ROLE.SuperAdmin]
      },
      {
        name: "Scheduler Logs",
        href: "/scheduler-logs",
        iconPath: ComputerLineIcon,
        permittedRoles: [USER_ROLE.SuperAdmin]
      },
      {
        name: "State51 Batch Ids",
        href: "/state51-batch-ids",
        iconPath: BatchIdIcon,
        permittedRoles: [USER_ROLE.SuperAdmin, USER_ROLE.DistroAdmin]
      },
      {
        name: "Release Upc Codes",
        href: "/upc-codes",
        iconPath: UpcScanIcon,
        permittedRoles: [USER_ROLE.SuperAdmin, USER_ROLE.DistroAdmin]
      },
      {
        name: "Track Isrc Codes",
        href: "/isrc-codes",
        iconPath: UpcScanIcon,
        permittedRoles: [USER_ROLE.SuperAdmin, USER_ROLE.DistroAdmin]
      },
      {
        name: "Territory Dsp List",
        href: "/territory-dsp",
        iconPath: DspIcon,
        permittedRoles: [USER_ROLE.SuperAdmin]
      },
      {
        name: "Registrations",
        href: "/registrations",
        iconPath: TeamLineIcon,
        permittedRoles: adminRoleList
      }
    ]*/
  }
]

export default navElements
